// Seeded randomness for the generators: mulberry32 seeded from the frame key (FNV-1a) and the generator
// version (palette.json art.genVersion), so every bake of a key is identical (research-artAudio §2).

export type Rand = () => number;

export function fnv1a(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

export function mulberry32(seed: number): Rand {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function seedOf(key: string, genVersion: number): number {
  return fnv1a(`${key}#${genVersion}`);
}

/** A value in [a, b). */
export function range(r: Rand, a: number, b: number): number {
  return a + (b - a) * r();
}
